interface CostTrackerProps {
  tokensUsed: number;
  apiCalls: number;
  estimatedCost: number;
}

export function CostTracker({ tokensUsed, apiCalls, estimatedCost }: CostTrackerProps) {
  return (
    <div className="flex items-center gap-4 px-4 py-2 bg-gray-50 rounded-lg border text-xs text-gray-600">
      <span>🪙 <strong>{tokensUsed.toLocaleString()}</strong> tokens</span>
      <span className="text-gray-300">|</span>
      <span>🔗 <strong>{apiCalls}</strong> API calls</span>
      <span className="text-gray-300">|</span>
      <span>💰 <strong>${estimatedCost.toFixed(4)}</strong> est. cost</span>
    </div>
  );
}
